import { Model } from "pinia-orm";

export default class SiteInformation extends Model {
  static entity = "siteInformations";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      clientName: this.string(""),
      siteName: this.string(""),
      address: this.string(""),
      postcode: this.string(""),
      city: this.string(""),
      department: this.string(""),
      locationPlan: this.attr(null),
      locationPlanName: this.string(""),
      currentUsage: this.string(""),
      usageTypologies: this.attr(null),
      currentTargets: this.attr(null),
      currentActivityName: this.string(""),
      isCurrentActivityPolluting: this.boolean(false),
      isWasteland: this.boolean(false),
      cadastralPlan: this.attr(null),
      cadastralPlanName: this.string(""),
      totalSurface: this.number(0),
      isSiteIcpe: this.boolean(false),
      currentRegime: this.string(""),
      typeDocumentAdministratif: this.string(""),
      date: this.attr(null),
      reference: this.string(""),
      socialReason: this.string(""),
      activityStatus: this.string(""),
      activityStartDateIndication: this.attr(null),
      activityStartDateYear: this.attr(null),
      activityEndDateIndication: this.attr(null),
      activityEndDateYear: this.attr(null),
      cessationAdministrative: this.attr(null),
      cessationDateIndication: this.attr(null),
      cessationDateYear: this.attr(null),
      administrativeSituation: this.string(""),
      project: this.attr(null),
      siteVisitPlan: this.attr(null),
      siteVisitPlanName: this.string(""),
      pollutionSource: this.attr(null),
      justification: this.string(""),
      specificContext: this.string(""),
    };
  }
}
